import { css } from 'styled-components';

import { SizeUnit } from '@utils/types';

type WithWidthProp = {
  width?: SizeUnit;
};

// iOS zooms into inputs smaller than 16px on focus. app/globals.css covers AntD inputs by class;
// BaseInput and DateInput (FormattedInputs) are not AntD inputs and include this instead.
export const IOS_INPUT_ZOOM_GUARD = css`
  @supports (-webkit-touch-callout: none) {
    @media (max-width: 1025px) {
      font-size: 16px !important;
    }
  }
`;

export const widthMixin = ({ width }: WithWidthProp) =>
  width
    ? css`
        width: min(${width}, 100vw);
      `
    : null;
